export default {
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '32px',
    backgroundColor: (theme) => theme.palette.grays.lightestGray,
    borderRadius: '24px',
    margin: 0,
  },
  checkBoxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '20px',
    backgroundColor: '#fff',
    border: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    padding: '20px',
    margin: 0,
    height: '63px',
    alignItems: 'center',
    'div:last-of-type': {
      width: 'auto',
    },
  },
  text: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: '8px',
    color: (theme) => theme.palette.grays.gray700,
    fontWeight: 600,
    fontSize: '1.125rem',
  },
};
